"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RenderDynamicFields = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _typography = _interopRequireDefault(require("britive-design-system/core/components/typography"));

var _constants = require("../constants");

var _OTPRenderer = _interopRequireDefault(require("../../../../../../../components/OTPRenderer/OTPRenderer"));

var _FileViewerRenderer = require("../../../../../../../components/FileViewerRenderer/FileViewerRenderer");

var _commonUtils = require("../../../../../../../utils/common-utils");

var _ActionButtons = require("./ActionButtons");

var _CopyButton = require("./CopyButton");

var _HighlightURLInText = require("./HighlightURLInText");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var RenderDynamicFields = function RenderDynamicFields(_ref) {
  var secretTemplateData = _ref.secretTemplateData,
      secretDetailData = _ref.secretDetailData,
      file = _ref.file,
      secretFileDownloadStatus = _ref.secretFileDownloadStatus,
      secretFileDownloadStatusCode = _ref.secretFileDownloadStatusCode,
      reloadSecretFile = _ref.reloadSecretFile,
      fetchNewOTP = _ref.fetchNewOTP,
      otp = _ref.otp,
      secretOTPFetchStatus = _ref.secretOTPFetchStatus,
      secretOTPFetchError = _ref.secretOTPFetchError,
      secretDetailsLoadTime = _ref.secretDetailsLoadTime,
      secretTemplateLoadTime = _ref.secretTemplateLoadTime,
      secretOTPFetchLoadTime = _ref.secretOTPFetchLoadTime;
  var fileSSTParameter = null;
  var otpParameter = null;
  var paramsWithOTPFieldAtLast = [];
  secretTemplateData.parameters.map(function (parameter) {
    if (parameter.type !== 'fileUpload' && parameter.type !== _commonUtils.otpType) {
      paramsWithOTPFieldAtLast.push(parameter);
    } else if (parameter.type === 'fileUpload') {
      fileSSTParameter = parameter;
    } else if (parameter.type === _commonUtils.otpType) {
      otpParameter = parameter;
    }
  });

  if (fileSSTParameter) {
    paramsWithOTPFieldAtLast.push(fileSSTParameter);
  }

  if (otpParameter) {
    paramsWithOTPFieldAtLast.push(otpParameter);
  }

  return paramsWithOTPFieldAtLast.map(function (parameter, index) {
    if (secretDetailData && secretDetailData.value && Object.keys(secretDetailData.value).length && parameter.type !== 'fileUpload' && parameter.type !== _commonUtils.otpSeedType && parameter.type !== _commonUtils.otpType && parameter.name in secretDetailData.value) {
      var _useState = (0, _react.useState)(parameter === null || parameter === void 0 ? void 0 : parameter.mask),
          _useState2 = _slicedToArray(_useState, 2),
          masked = _useState2[0],
          setMasked = _useState2[1];

      var _useState3 = (0, _react.useState)(false),
          _useState4 = _slicedToArray(_useState3, 2),
          showCopy = _useState4[0],
          setShowCopy = _useState4[1]; // If the parameters are present in the secret details as well then only will display it


      return /*#__PURE__*/_react.default.createElement("div", {
        key: "".concat(_constants.templateKey).concat(index),
        className: _constants.classes.secretViewSpacing,
        onMouseOver: function onMouseOver() {
          return setShowCopy(true);
        },
        onMouseLeave: function onMouseLeave() {
          return setShowCopy(false);
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: _constants.classes.secretViewLabel
      }, /*#__PURE__*/_react.default.createElement(_typography.default, {
        variant: "label2"
      }, parameter === null || parameter === void 0 ? void 0 : parameter.name)), /*#__PURE__*/_react.default.createElement("div", {
        className: _constants.classes.secretViewValue
      }, /*#__PURE__*/_react.default.createElement(_ActionButtons.ActionButtons, {
        key: index,
        secretDetailData: secretDetailData,
        templateParameter: parameter,
        masked: masked,
        setMasked: setMasked
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: _constants.classes.secretValueRender
      }, masked && /*#__PURE__*/_react.default.createElement(_typography.default, {
        variant: "label1"
      }, '*'.repeat(_constants.maskedRepeatCount)), !masked && /*#__PURE__*/_react.default.createElement(_typography.default, {
        variant: "label1"
      }, /*#__PURE__*/_react.default.createElement(_HighlightURLInText.HighlightURLInText, {
        text: secretDetailData === null || secretDetailData === void 0 ? void 0 : secretDetailData.value[parameter === null || parameter === void 0 ? void 0 : parameter.name]
      })), showCopy && /*#__PURE__*/_react.default.createElement(_CopyButton.CopyButton, {
        secretDetailData: secretDetailData,
        templateParameter: parameter
      }))));
    } else if (parameter.type === 'fileUpload') {
      return /*#__PURE__*/_react.default.createElement(_FileViewerRenderer.FileViewerRenderer, {
        key: parameter.name,
        file: file,
        fileFieldName: parameter.name,
        fileName: (0, _commonUtils.getFileName)(secretDetailData, parameter),
        secretFileDownloadStatus: secretFileDownloadStatus,
        secretFileDownloadStatusCode: secretFileDownloadStatusCode,
        reloadSecretFile: reloadSecretFile,
        classes: _constants.classes,
        translatedStrings: _constants.translatedStrings
      });
    } else if (parameter.type === _commonUtils.otpType) {
      return secretDetailData !== null && secretDetailData !== void 0 && secretDetailData.value[_commonUtils.otpName] ? /*#__PURE__*/_react.default.createElement(_OTPRenderer.default, {
        fetchNewOTP: fetchNewOTP,
        selectedItemAncestors: secretDetailData.path,
        otp: otp || (secretDetailData === null || secretDetailData === void 0 ? void 0 : secretDetailData.value[_commonUtils.otpName]),
        secretOTPFetchStatus: secretOTPFetchStatus,
        secretOTPFetchError: secretOTPFetchError,
        secretOTPFetchLoadTime: secretOTPFetchLoadTime,
        reloadTime: 30,
        initialLoadingTime: secretTemplateLoadTime + secretDetailsLoadTime
      }) : null;
    } else {
      return null;
    }
  });
};

exports.RenderDynamicFields = RenderDynamicFields;
RenderDynamicFields.propTypes = {
  secretTemplateData: _propTypes.default.object,
  secretDetailData: _propTypes.default.object,
  getMaskedActionButtons: _propTypes.default.func,
  maskedFields: _propTypes.default.object,
  file: _propTypes.default.object,
  initialLoadingTime: _propTypes.default.number,
  fetchNewOTP: _propTypes.default.func,
  otp: _propTypes.default.string,
  secretOTPFetchStatus: _propTypes.default.string,
  secretOTPFetchError: _propTypes.default.string,
  selectedItemAncestors: _propTypes.default.array
};